"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buffer_1 = require("buffer");
var crypto = require("crypto");
var pasteparser_1 = require("./pasteparser");
// Latest parser which reads BSON-encoded binary data
// and returns a paste.
var BlobParserV2 = /** @class */ (function () {
    function BlobParserV2(data, name, key) {
        this.data = data;
        this.name = name;
        this.key = key;
    }
    // Safe to assume this only supported the v3+ paste storage.
    // These pastes are housed by BlobDataIs. The BSON is parsed and provided
    // at construction.
    BlobParserV2.prototype.decrypt = function () {
        if (typeof this.data === 'string') {
            throw Error('Unsupported data type for Blob API V2.');
        }
        var key = crypto.pbkdf2Sync(this.key, (this.data.salt.buffer), this.data.iterations, 5, 'sha512');
        var decipher = crypto.createDecipher('aes256', key);
        var decrypted = buffer_1.Buffer.concat([decipher.update((this.data.data.buffer)), decipher.final()]);
        return pasteparser_1.default.parse(this.name, this.key, decrypted);
    };
    // TODO: Event listener? This name doesn't match func.
    BlobParserV2.prototype.decryptAsync = function (progress, complete) {
        var _this = this;
        if (typeof this.data === 'string') {
            throw Error('Unsupported data type for Blob API V2.');
        }
        var key = crypto.pbkdf2Sync(this.key, (this.data.salt.buffer), this.data.iterations, 5, 'sha512');
        var decipher = crypto.createDecipher('aes256', key);
        var decrypted;
        decipher.on('readable', function () {
            var part = decipher.read();
            if (part) {
                if (decrypted) {
                    decrypted = buffer_1.Buffer.concat([decrypted, part]);
                }
                else {
                    decrypted = part;
                }
                // Allocated size of buffer / original buffer size
                if (typeof _this.data !== "string") {
                    progress(decrypted.byteLength / _this.data.data.buffer.byteLength);
                }
            }
        });
        decipher.on('end', function () {
            progress(1);
            complete(pasteparser_1.default.parse(_this.name, _this.key, decrypted));
        });
        // smooth out progress bar
        var chunkSize = 512 * 1024;
        if (this.data.data.length <= chunkSize) {
            decipher.write((this.data.data.buffer));
        }
        else {
            for (var offset = 0; offset < this.data.data.buffer.byteLength; offset += chunkSize) {
                var end = offset + chunkSize;
                decipher.write((this.data.data.buffer.slice(offset, end > this.data.data.byteLength ? this.data.data.byteLength : end)));
            }
        }
        decipher.end();
    };
    return BlobParserV2;
}());
exports.default = BlobParserV2;
